import { render } from "./WarehouseForm.vue?vue&type=template&id=fc892cc8"
import script from "./WarehouseForm.vue?vue&type=script&lang=js"
export * from "./WarehouseForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__